export const ROLES = ["admin", "planner", "supervisor", "executor", "viewer"];
export const ROLE_LABELS = {
    admin: "Admin",
    planner: "Planner",
    supervisor: "Supervisor",
    executor: "Executor",
    viewer: "Viewer",
};
export const PERMISSIONS = [
    "plans.view",
    "plans.create",
    "plans.edit",
    "plans.share",
    "plans.export",
    "plans.delete",
    "plans.favorite",
    "members.manage",
    "settings.manage",
    "billing.manage",
    "data.manage",
];
export const ROLE_PERMISSIONS = {
    admin: {
        "plans.view": true,
        "plans.create": true,
        "plans.edit": true,
        "plans.share": true,
        "plans.export": true,
        "plans.delete": true,
        "plans.favorite": true,
        "members.manage": true,
        "settings.manage": true,
        "billing.manage": true,
        "data.manage": true,
    },
    planner: {
        "plans.view": true,
        "plans.create": true,
        "plans.edit": true,
        "plans.share": true,
        "plans.export": true,
        "plans.delete": true,
        "plans.favorite": true,
        "members.manage": false,
        "settings.manage": false,
        "billing.manage": false,
        "data.manage": false,
    },
    supervisor: {
        "plans.view": true,
        "plans.create": false,
        "plans.edit": false,
        "plans.share": true,
        "plans.export": true,
        "plans.delete": false,
        "plans.favorite": false,
        "members.manage": false,
        "settings.manage": false,
        "billing.manage": false,
        "data.manage": false,
    },
    executor: {
        "plans.view": true,
        "plans.create": false,
        "plans.edit": false,
        "plans.share": false,
        "plans.export": false,
        "plans.delete": false,
        "plans.favorite": false,
        "members.manage": false,
        "settings.manage": false,
        "billing.manage": false,
        "data.manage": false,
    },
    viewer: {
        "plans.view": true,
        "plans.create": false,
        "plans.edit": false,
        "plans.share": false,
        "plans.export": false,
        "plans.delete": false,
        "plans.favorite": false,
        "members.manage": false,
        "settings.manage": false,
        "billing.manage": false,
        "data.manage": false,
    },
};
export function hasPermission(role, permission) {
    return ROLE_PERMISSIONS[role][permission];
}
export function isRole(value) {
    return ROLES.includes(value);
}
//# sourceMappingURL=role-policy.js.map